import axios from 'axios';

const API_URL = '/api/v1/live';

// Get token for live class
const getToken = async (role, userName) => {
  const token = localStorage.getItem('token');
  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };
  const response = await axios.get(`${API_URL}/token?role=${role}&userName=${encodeURIComponent(userName)}`, config);
  return response.data;
};

const liveService = {
  getToken
};

export default liveService; 